var map = {
	"./baoyou.svg": "injj",
	"./channel.svg": "5e3z",
	"./channelDetail.svg": "9qon",
	"./channelList.svg": "DYRm",
	"./dashboard.svg": "BCGP",
	"./document.svg": "mDNq",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./fapiao.svg": "+Yqz",
	"./form.svg": "sTIr",
	"./fuli.svg": "GUb6",
	"./home.svg": "U9Ws",
	"./invite.svg": "r/7f",
	"./invited.svg": "nTdp",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./peisong.svg": "nCq8",
	"./pintuan.svg": "DT0k",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./promotion.svg": "HzCk",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./system-aboutus.svg": "FtEI",
	"./system-agreement.svg": "fDma",
	"./system-notice.svg": "5bp4",
	"./system.svg": "Jax1",
	"./table.svg": "oSYw",
	"./task.svg": "EK3d",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user-chengzhang.svg": "oxN7",
	"./user-jifen.svg": "xqSy",
	"./user-yonghu.svg": "/zda",
	"./user.svg": "VdD3",
	"./video.svg": "3JNx",
	"./yunfei.svg": "6zKl",
	"./zhuanti.svg": "iTaP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 21